<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center
  v-container(fluid)
    v-row(justify="space-around" align="center")
      v-col.text-center
        h3.mb-6.ibm.text-h4.text-md-h3.primary--text Gestão simples
        h5.mb-6.mb-sm-10.text-h5.heebo.grey--text.text--darken-4 Acompanhe o desempenho e evolução de sua equipe de forma ágil e objetiva.
    v-row.simple-management(justify="space-around" align="center")
      v-col(cols=12 sm=8)
        .mx-4.mx-sm-0.video-container
          iframe(
            src="https://www.youtube-nocookie.com/embed/5DEq5cWNYt8"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="border-radius: 12px"
          )
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
